import { last } from 'ramda';

export default last;
